import React from 'react';
import { Form } from '../../../ui/universe';
import { Textarea, Tooltip, Button } from 'tdesign-react';

/**
 * Textarea 参数渲染器
 * 支持 presets（示例规则一键回填）、清空、字数上限截断与禁用态
 */
function TextareaRenderer({ params, value, disabled, showClose, placeholder, onClose, onChange }) {
  const max = params.maxLength ?? params.max;
  const text = typeof value === 'string' ? value : '';
  const presets = params.presets || [];

  const handleChange = (val) => {
    const next = max && val.length > max ? val.slice(0, max) : val;
    onChange && onChange(next);
  };

  const applyPreset = (e, preset) => {
    e.stopPropagation();
    if (disabled) return;
    onChange && onChange(preset.value, undefined, { presetConfig: preset.config });
  };

  const renderLabel = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px',
        width: '100%',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {params.label}
        {params.des && (
          <Tooltip content={params.des} theme="light">
            <span className="ocrDemo-icon-question"></span>
          </Tooltip>
        )}
      </span>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}>
        {presets.length > 0 && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            {presets.map((preset, index) => (
              <Button
                key={index}
                theme="primary"
                variant="text"
                size="small"
                disabled={disabled}
                onClick={(e) => applyPreset(e, preset)}
              >
                <span
                  style={{
                    fontWeight: preset.value === text ? 600 : 400,
                    color: preset.value === text
                      ? 'var(--td-brand-color)'
                      : 'var(--td-text-color-secondary)',
                  }}
                >
                  {preset.label}
                </span>
              </Button>
            ))}
          </span>
        )}
        {!disabled && text && (
          <Button
            theme="default"
            variant="text"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onChange && onChange('');
            }}
          >
            清空
          </Button>
        )}
      </span>
    </div>
  );

  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={renderLabel()}
    >
      <div style={{ width: '100%' }}>
        <Textarea
          value={text}
          maxlength={max}
          disabled={disabled}
          autosize={{ minRows: params.rows || 4, maxRows: params.maxRows || 30 }}
          placeholder={params.placeholder || placeholder}
          onChange={handleChange}
        />
        {params.tips && (
          <div style={{ marginTop: '4px', fontSize: '12px', color: '#999' }}>
            {params.tips}
          </div>
        )}
      </div>
      {showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>}
    </Form.Item>
  );
}

export default TextareaRenderer;
